import clsx from 'clsx';
import React, { type PropsWithChildren } from 'react';

import styles from './VigboFeature.css';

export interface VigboFeatureProps {
    className?: string;
}

export function VigboFeature({ className, children }: PropsWithChildren<VigboFeatureProps>) {
    return <div className={clsx(styles.root, className)}>{children}</div>;
}
